import { SankeyDiagramChartComponent } from './components/sankey-diagram-chart/sankey-diagram-chart.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleChartsModule } from 'angular-google-charts';
import { InvisibleChildComponent } from './components/invisible-child/invisible-child.component';
import { EchartsLinechartComponent } from './components/echarts-linechart/echarts-linechart.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { GoogleColumnchartComponent } from './components/google-columnchart/google-columnchart.component';
import { GoogleAreachartComponent } from './components/google-areachart/google-areachart.component';
import { GoogleBarchartComponent } from './components/google-barchart/google-barchart.component';
import { PathsChartComponent } from './components/paths-chart/paths-chart.component';
import { GoogleBubblechartComponent } from './components/google-bubblechart/google-bubblechart.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { GooglePiechartComponent } from './components/google-piechart/google-piechart.component';
import { PolarAreaChartComponent } from './components/polar-area-chart/polar-area-chart.component';
import { AlertPanelComponent } from './components/alert-panel/alert-panel.component';
import { RadarChartComponent } from './components/radar-chart/radar-chart.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { LoaderComponent } from './components/loader/loader.component';
import { MatModule } from './mat/mat.module';
import { ParkingMapsWidgetComponent } from './widgets/parking-maps-widget/parking-maps-widget.component';
import { StackedBarchartComponent } from './components/stacked-barchart/stacked-barchart.component';
import { EchartsHeatmapComponent } from './components/echarts-heatmap/echarts-heatmap.component';
import { TrafficMapsWidgetComponent } from './widgets/traffic-maps-widget/traffic-maps-widget.component';
import { LottieComponent } from 'ngx-lottie';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { PresenceDotComponent } from './components/presence-dot/presence-dot.component';
import { GatewayReachComponent } from './components/gateway-reach/gateway-reach.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { LoadingPanelComponent } from './components/loading-panel/loading-panel.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { RecipientPickerComponent } from './components/recipient-picker/recipient-picker.component';
import { RecipientsEditorComponent } from './components/recipients-editor/recipients-editor.component';
import { RowActionsComponent } from './components/row-actions/row-actions.component';
import { RowActionDirective } from './directives/row-action.directive';
import { PageActionsComponent } from './components/page-actions/page-actions.component';
import { PageActionDirective } from './directives/page-action.directive';
import { SheetGrabDirective } from './directives/sheet-grab.directive';

@NgModule({
  declarations: [
    InvisibleChildComponent,
    LoaderComponent,
    EchartsLinechartComponent,
    GoogleColumnchartComponent,
    GoogleAreachartComponent,
    GoogleBarchartComponent,
    SankeyDiagramChartComponent,
    PathsChartComponent,
    GoogleBubblechartComponent,
    SearchbarComponent,
    GooglePiechartComponent,
    PolarAreaChartComponent,
    AlertPanelComponent,
    RadarChartComponent,
    ParkingMapsWidgetComponent,
    StackedBarchartComponent,
    EchartsHeatmapComponent,
    TrafficMapsWidgetComponent,
    VideoPlayerComponent,
    PaginatorComponent,
    LoadingPanelComponent,
    ExportButtonComponent,
    RecipientPickerComponent,
    RecipientsEditorComponent,
    RowActionsComponent,
    RowActionDirective,
    PageActionsComponent,
    PageActionDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatModule,
    MatBottomSheetModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    GoogleChartsModule,
    DragDropModule,
    NgxDropzoneModule,
    LottieComponent,
    SheetGrabDirective,
    PresenceDotComponent,
    GatewayReachComponent
  ],
  exports: [
    MatModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent,
    GoogleChartsModule,
    EchartsLinechartComponent,
    DragDropModule,
    GoogleColumnchartComponent,
    GoogleAreachartComponent,
    GoogleBarchartComponent,
    SankeyDiagramChartComponent,
    PathsChartComponent,
    GoogleBubblechartComponent,
    SearchbarComponent,
    GooglePiechartComponent,
    PolarAreaChartComponent,
    AlertPanelComponent,
    RadarChartComponent,
    NgxDropzoneModule,
    ParkingMapsWidgetComponent,
    StackedBarchartComponent,
    EchartsHeatmapComponent,
    TrafficMapsWidgetComponent,
    VideoPlayerComponent,
    PresenceDotComponent,
    GatewayReachComponent,
    PaginatorComponent,
    LoadingPanelComponent,
    ExportButtonComponent,
    RecipientPickerComponent,
    RecipientsEditorComponent,
    RowActionsComponent,
    RowActionDirective,
    PageActionsComponent,
    PageActionDirective
  ]
})
export class SharedModule { }
